<template>
  <span class="modalWrapper">
    <button v-on:click="toggleContent" class="w3-button w3-black">{{labelText}}</button>

    <div id="id01" class="w3-modal" v-bind:class="{ 'w3-show': contentVisible}">
      <div class="w3-modal-content w3-card-4">
        <header class="w3-container w3-teal">
          <span v-on:click="toggleContent()" class="w3-button w3-display-topright">&times;</span>
          <h2>{{labelText}}</h2>
        </header>
        <div class="w3-container">
          <slot></slot>
        </div>
        <footer class="w3-container w3-teal"></footer>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  name: "ModalContainer",
  data: function() {
    return {
      contentVisible: false
    };
  },
  props: ["labelText"],
  methods: {
    toggleContent: function() {
      console.log("modal toggle");
      this.contentVisible = !this.contentVisible;
    }
  }
};
</script>

<style scoped>
</style>
